(function () {
    'use strict';

    angular
        .module('riskEditModule')
        .controller('RiskSubRisksController', Controller);

    Controller.$inject = ['$scope', '$state', 'grcRiskService', 'subRisks'];

    function Controller($scope, $state, grcRiskService, subRisks) {
        $scope.subRisks = subRisks;

        $scope.addSubRisk = function () {
            var subRiskLevelValue = $scope.risk.RiskLevel.Value == 'Top' ? 'Key' : 'Department';

            $state.go('riskKeyOrDeptAdd', {
                RiskLevelValue: subRiskLevelValue,
                ParentRiskID: $scope.risk.RiskID
            });
        };

        // Get All Risk Levels
        $scope.riskLevels = [];
        grcRiskService
            .getAllRiskLevels()
            .then(function (riskLevels) {
                $scope.riskLevels = riskLevels;
            });

        $scope.getSubRisksBoxTitle = function (parentRisk) {
            if (_.isUndefined(parentRisk)) return;
            if (!$scope.riskLevels.length) return;

            if (parentRisk.RiskLevel.IsTopRisk) {
                var subRiskLevel = _.find($scope.riskLevels, { IsKeyRisk: true });
                return subRiskLevel.TitleEN + ' Risks';
            }

            if (parentRisk.RiskLevel.IsKeyRisk) {
                var subRiskLevel = _.find($scope.riskLevels, { IsDepartmentRisk: true });
                return subRiskLevel.TitleEN + ' Risks';
            }
        };
        
    }
})();